import ScoreCardFilters from './ScoreCardFilters';

export default ScoreCardFilters;
